import React from 'react';
import '../../styles/RateCard.css';

const PublicationCalendar = () => {
    return (
        <section className="publication-calendar-section py-5">
            <div className="container">
                <div className='rate-card-subtitle-container text-center mt-5 mb-5' data-aos="fade-up" data-aos-delay="200">
                    <h2 className='rate-card-subtitle pb-2'>Calendario de <span className='p-2'>publicaciones</span></h2>
                    <p>Más de 6 guías educativas | Costos a cotizar FP/FC</p>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-lg-3 col-md-6 mb-4' data-aos="fade-up" data-aos-delay="200">
                        <div className='publication-calendar-col rounded shadow-lg pt-3 pb-3'>
                            <h3>FEBRERO Y SEPTIEMBRE</h3>
                            <img src="assets/febrero-y-septiembre.png" alt="imagen calendar section" className='img-fluid w-100' />
                            <p className='mt-4'><b>Una guía que reúne las herramientas esenciales para tomar el control de tu corazón</b>, desde el punto de vista de
                                la prevención, alternativas terapéuticas y hábitos que debes evitar.
                            </p>

                            <p className='bold'>
                                <b>
                                    Fecha de cierre Feb 2025<br />
                                    20/enero/2025
                                </b>
                            </p>

                            <p>
                                <b>
                                    Fecha de cierre Sept 2025<br />
                                    13/agosto/2025
                                </b>
                            </p>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4'  data-aos="fade-up" data-aos-delay="300">
                        <div className='publication-calendar-col rounded shadow-lg pt-3 pb-3'>
                            <h3>MAYO Y OCTUBRE</h3>
                            <img src="assets/mayo-y-octubre.png" alt="imagen calendar section" className='img-fluid w-100' />
                            <p className='mt-4'><b>A través de esta revista se educa sobre las condiciones autoinmunes e inflamatorias,</b>
                                desde los aspectos más básicos hasta los más complejos, abarcando tanto el punto de vista clínico, como el humano.
                            </p>

                            <p>
                                <b>
                                    Fecha de cierre Mayo 2025<br />
                                    11/abril/2025
                                </b>
                            </p>

                            <p>
                                <b>
                                    Fecha de cierre Oct 2025<br />
                                    10/sept/2025
                                </b>
                            </p>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4'  data-aos="fade-up" data-aos-delay="400">
                        <div className='publication-calendar-col rounded shadow-lg pt-3 pb-3'>
                            <h3>JUNIO</h3>
                            <img src="assets/junio.png" alt="imagen calendar section" className='img-fluid w-100' />
                            <p className='mt-4'><b>Es una revista especializada Oncología.</b>
                            </p>

                            <p>
                                <b>
                                    Fecha de cierre Junio  2025<br />
                                    9/mayo/2025

                                </b>
                            </p>
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-6 mb-4' data-aos="fade-up" data-aos-delay="500">
                        <div className='publication-calendar-col rounded shadow-lg pt-3 pb-3'>
                            <h3>DICIEMBRE</h3>
                            <img src="assets/diciembre.png" alt="imagen calendar section" className='img-fluid w-100' />
                            <p className='mt-4'><b>Una publicación que reúne</b> las historias de un grupo de guerreros que han logrado tomar el control de su condición de salud.

                            </p>

                            <p>
                                <b>
                                    Fecha de cierre NOV  2025<br />
                                    9/nov/2025

                                </b>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PublicationCalendar;